import React from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import WidgetDescription from '../WidgetDescription';
import DoughnutChart from '../../Charts/DoughnutChart';
import TableToggle from '../TableToggle';
import { Col, Row } from 'react-bootstrap';
import KeyValueData from '../../Charts/KeyValueData';
import useTableToggle from '../../Hooks/useTableToggle';
import NoData from '../NoData';
import { colors } from '../../../utilities/formats';

export default function PellPercentage({ institutionData }) {

    const { table, handleTable } = useTableToggle();
    const title = 'Pell Percentage';
    const pell = institutionData.post_meta.pell_2023.value;

    if (!pell) {
        return <NoData widgetTitle={title} />;
    }

    const dataset = {
        labels: ['Pell', 'Non-Pell'],
        datasets: [
            {
                backgroundColor: [colors.blue, colors.gray],
                data: [
                    parseFloat(pell) * 100,
                    (1 - pell) * 100
                ]
            }
        ]
    }
    return (
        <Widget className="pell-percentage">
            <Row gap={5} gap-lg={0}>
                <Col xs={12} sm={9}>
                    <WidgetTitle>{title}</WidgetTitle>
                </Col>
                <Col xs={12} sm={3}>
                    <TableToggle handleTable={handleTable} table={table} />
                </Col>
            </Row>
            <WidgetDescription>
                Percent of degree- or certificate-seeking undergraduate students who received a Pell Grant.
            </WidgetDescription>
            {!table ? (
                <div className="d-block d-md-flex">
                    <div className="w-50">
                        <DoughnutChart datasets={dataset} centerText='Pell Percentage' centerNumber={`${(pell * 100).toFixed(0)}%`} legendDiv="pellLegend" numberFormat={["percent", 0]} />
                    </div>
                    <div className='dotLegend w-50 d-flex align-items-center p-3' id='pellLegend'></div>
                </div>
            ) : <KeyValueData data={
                [
                    {
                        label: 'Pell Percentage',
                        value: `${(pell * 100).toFixed(3)}%`
                    },
                    {
                        label: 'Non-Pell Percentage',
                        value: `${((1 - pell) * 100).toFixed(3)}%`
                    }
                ]} />}

        </Widget>
    );
}